import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Linkedin } from "lucide-react";
import { EDITOR_LINKEDIN } from "@/lib/api";
import { api, formatApiError } from "@/lib/api";

export const NewsletterForm = ({ dark = false, testid = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. The Tuesday Roast lands every Tuesday at 5am.");
      setEmail("");
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className={`flex border ${dark ? "border-white/20" : "border-[#0A0A0A]"}`}>
      <input data-testid={`${testid}-email-input`} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your work email"
        className={`flex-1 min-w-0 bg-transparent px-4 py-3 text-sm outline-none ${dark ? "text-white placeholder:text-white/40" : ""}`} />
      <button data-testid={`${testid}-submit-btn`} disabled={busy} className={`px-4 shrink-0 flex items-center gap-2 text-sm font-medium transition-colors ${dark ? "bg-[#E5332A] text-white hover:bg-[#FF4B40]" : "bg-[#0A0A0A] text-white hover:bg-[#E5332A]"}`}>
        Subscribe <ArrowRight size={14} />
      </button>
    </form>
  );
};

export const Footer = () => (
  <footer className="bg-[#0A0A0A] text-[#E7E7E7] mt-24 relative grain" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid gap-12 lg:grid-cols-12 relative">
      <div className="lg:col-span-5">
        <div className="bg-white inline-block p-3"><img src="/logo.png" alt="Africa Brew Brief" className="h-16 w-auto" data-testid="footer-logo" /></div>
        <p className="overline text-[#E5332A] mt-4">An Africa One Group Publication</p>
        <a href={EDITOR_LINKEDIN} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="inline-flex items-center gap-2 mt-4 text-sm text-white/80 hover:text-white"><Linkedin size={16} /> Follow the editor, Wilbert Chaniwa, on LinkedIn</a>
        <p className="mt-6 text-sm leading-relaxed text-[#E7E7E7]/70 max-w-md">
          Africa is not a single story. It is 54 sovereign economies, hundreds of distinct food systems and a generation rewriting the rules of global trade. We contextualise, analyse and illuminate.
        </p>
        <div className="mt-8 max-w-md"><NewsletterForm dark testid="footer-newsletter" /></div>
      </div>
      <div className="lg:col-span-2 lg:col-start-7 text-sm space-y-3">
        <p className="overline text-[#E5332A] mb-4">Read</p>
        <Link to="/news?type=brief" className="block hover:text-white">Daily Briefs</Link>
        <Link to="/news?type=analysis" className="block hover:text-white">Analysis</Link>
        <Link to="/news?type=newsletter" className="block hover:text-white">Newsletters</Link>
        <Link to="/research" className="block hover:text-white">Research & Reports</Link>
      </div>
      <div className="lg:col-span-2 text-sm space-y-3">
        <p className="overline text-[#E5332A] mb-4">Membership</p>
        <Link to="/pricing" className="block hover:text-white">Pro & Institutional</Link>
        <Link to="/support" className="block hover:text-white">Support our journalism</Link>
        <Link to="/account" className="block hover:text-white">My account</Link>
      </div>
      <div className="lg:col-span-2 text-sm space-y-3">
        <p className="overline text-[#E5332A] mb-4">Commercial</p>
        <Link to="/sponsor" className="block hover:text-white">Sponsor an article</Link>
        <Link to="/sponsor" className="block hover:text-white">Media kit</Link>
        <Link to="/sponsor" className="block hover:text-white">Research partnerships</Link>
        <Link to="/events" data-testid="footer-events-link" className="block hover:text-white">The Origin Cup events</Link>
      </div>
    </div>
    <div className="border-t border-white/10 relative">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-6 text-xs text-[#E7E7E7]/50 flex flex-col sm:flex-row justify-between gap-2">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} All Rights Reserved Africa One Group · <a href="https://www.africaonegroup.co" target="_blank" rel="noopener noreferrer" className="hover:text-white underline-offset-2 hover:underline">www.africaonegroup.co</a></span>
        <span>Market data shown is indicative and for information only. Sponsored content is clearly labelled.</span>
      </div>
    </div>
  </footer>
);
